module.exports = __webpack_public_path__ + "img/avatar_9.42ef7c3d.jpg";